module.exports = __webpack_public_path__ + "static/media/start-buying-info.7ed5e8fc.png";